module.exports = __webpack_public_path__ + "img/202603_03.eac44d4e.png";